import Vue from "vue";
import { Store, Module, ActionContext } from "vuex";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import ListMutations from "./list-mutations";
import Project from "../entities/project";
import Cookies from "js-cookie";

let _: any = require("lodash");

const LAST_SELECTED_PROJECT_ID_KEY: string = "lastSelectedProjectId";
const LAST_SELECTED_PROJECT_MEMBER_ID_KEY: string = "lastSelectedProjectMemberId";
const cookieExpires: number = 1;

let getLastSelectedProjectIdFromCookie = function(): string {
  return Cookies.get(LAST_SELECTED_PROJECT_ID_KEY);
};

let getLastSelectedProjectMemberIdFromCookie = function(): number {
  let value: string = Cookies.get(LAST_SELECTED_PROJECT_MEMBER_ID_KEY);

  return value ? Number(value) : NaN;
};

// tslint:disable-next-line: interface-name
interface ProjectState {
  loading: boolean;
  lastSelectedProjectId: string;
  lastSelectedMemberId: number;
  projects: Project[];
  editableProjects: Project[];
  myProjects: Project[];
  currentProject: Project;
  currentProjectLoadingCount: number;
  currentProjectMembers: [];
}
//class BioMutations extends ListMutations<Project> {}

export const state: ProjectState = {
  loading: false,
  lastSelectedProjectId: getLastSelectedProjectIdFromCookie() || null,
  lastSelectedMemberId: getLastSelectedProjectMemberIdFromCookie() || null,
  projects: new Array<Project>(),
  editableProjects: new Array<Project>(),
  myProjects: new Array<Project>(),
  currentProject: new Project(),
  currentProjectLoadingCount: 0,
  currentProjectMembers: []
};

const projectModule: Module<ProjectState, any> = {
  namespaced: true,
  state,
  getters: {
    roleTitle: (state, getters) => role => {
      if (role === 1) {
        return getters.memberRoleTitle;
      } else {
        return "Fan";
      }
    },
    memberRoleTitle: state => {
      return "Member";
    },
    canAdd: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;
      if (billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          return member.grantedPermissions.includes("Bio.AddBio");
        }
      }

      return false;
    },
    canEdit: state => project => {
      return project && project.grantedPermissions && project.grantedPermissions.includes("Bio.EditBio");
    },
    canEditCurrentProject: (state, getters) => {
      return state.currentProject && state.currentProject.grantedPermissions && state.currentProject.grantedPermissions.includes("Bio.EditBio");
    },
    canInviteMemberInCurrentProject: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;

      if (state.currentProject && state.currentProject.grantedPermissions && billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          let permissions = state.currentProject.grantedPermissions.concat(member.grantedPermissions);
          return permissions.includes("Bio.AssignAuthorRole") || permissions.includes("Bio.AssignFan");
        }
      }

      return false;
    },
    getRoleDetails: (state, getters, rootState) => role => {
      if (role === 4) {
        return {
          value: 4,
          name: "fan",
          title: "Fan only",
          description: 'Fan only can "see-only" all project information. Not able to add, edit, and delete project information.'
        };
      } else if (role === 6) {
        return {
          value: 6,
          name: "authorAndMember",
          title: "Author & Contributor",
          description: "Both author & contributor can add, edit, and delete project information."
        };
      } else {
        return null;
      }
    },
    currentProjectInviteRoles: (state, getters, rootState) => (memberId, project) => {
      let billingAccount = rootState.billing.billingAccount;
      if (!project) {
        project = state.currentProject;
      }

      let results = [];
      if (project && project.grantedPermissions && billingAccount) {
        let members = billingAccount.members.filter(m => m.memberId == memberId);
        if (members.length === 1) {
          let member = members[0];

          results.push(
            Object.assign(
              {
                disabled: !(project.grantedPermissions.includes("Bio.AssignAuthorRole") && member.grantedPermissions.includes("Bio.BeAuthor"))
              },
              getters.getRoleDetails(6)
            )
          );

          results.push(
            Object.assign(
              {
                disabled: !(project.grantedPermissions.includes("Bio.AssignFan") && member.grantedPermissions.includes("Bio.BeFan"))
              },
              getters.getRoleDetails(4)
            )
          );
        }
      }

      return results;
    }
  },
  actions: {
    async getMyProjects(context: any, payload: any) {
      context.state.loading = true;
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      await Ajax.get(`/api/services/app/Project/GetMyProjects?billingAccountId=${billingAccountId}`).then(response => {
        let projects = response.data.result.myProjects;
        projects.forEach(project => {
          project.hashTagList = project.hashTags ? JSON.parse(project.hashTags) : [];
        });
        context.state.projects = projects;
        context.state.myProjects = projects;
      });
      context.state.loading = false;
    },
    create(context: ActionContext<ProjectState, any>, payload: any) {
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      payload.data.billingAccountId = billingAccountId;

      return Ajax.post("/api/services/app/Project/Create", payload.data).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    update(context: ActionContext<ProjectState, any>, payload: any) {
      return Ajax.put("/api/services/app/Project/Update", payload.data).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    copy(context: ActionContext<ProjectState, any>, payload: any) {
      Ajax.post("/api/services/app/Project/Copy", payload.data).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    delete(context: ActionContext<ProjectState, any>, payload: any) {
      Ajax.delete("/api/services/app/Project/Delete?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    async undelete(context: ActionContext<ProjectState, any>, payload: any) {
      Ajax.post("/api/services/app/Project/Undelete?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    async unarchive(context: ActionContext<ProjectState, any>, payload: any) {
      Ajax.post("/api/services/app/Project/Unarchive?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyProjects", {});
      });
    },
    async get(context: any, payload: any) {
      context.state.loading = true;
      await Ajax.get("/api/services/app/Project/Get?Id=" + payload.id).then(response => {
        let project = response.data.result as Project;

        context.state.currentProject = project;
        context.state.currentProjectLoadingCount += 1;

        context.state.currentProjectMembers = project.members
          .filter(member => member.role !== 4)
          .map(member => {
            let roleName = member.role === 5 ? "Member" : "";
            return {
              id: member.memberId,
              name: `${member.memberName} - ${roleName}`,
              role: member.role,
              roleName: roleName
            };
          });
      });
      context.state.loading = false;

      return context.state.currentProject;
    },
    async acceptInvitation(context: ActionContext<ProjectState, any>, payload: any) {
      let result = null;

      await Ajax.post("/api/services/app/Project/AcceptInvitation", payload).then(response => {
        result = response;
      });

      return result;
    },
    async inviteMember(context: ActionContext<ProjectState, any>, payload: any) {
      await Ajax.post("/api/services/app/Project/InviteMember", payload.data);
    },
    async updateMember(context: ActionContext<ProjectState, any>, payload: any) {
      await Ajax.put("/api/services/app/Project/UpdateMember", payload.data);
    },
    async removeMember(context: ActionContext<ProjectState, any>, payload: any) {
      let queryString = Object.keys(payload.data)
        .map(key => {
          return encodeURIComponent(key) + "=" + encodeURIComponent(payload.data[key]);
        })
        .join("&");
      await Ajax.delete(`/api/services/app/Project/RemoveMember?${queryString}`);
    },
    async upsertTeam(context: ActionContext<ProjectState, any>, payload: any) {
      return Ajax.post("/api/services/app/Project/UpsertTeam", payload.data);
    },
    async removeTeam(context: ActionContext<ProjectState, any>, payload: any) {
      let queryString = Object.keys(payload.data)
        .map(key => {
          return encodeURIComponent(key) + "=" + encodeURIComponent(payload.data[key]);
        })
        .join("&");
      return Ajax.delete(`/api/services/app/Project/RemoveTeam?${queryString}`);
    },
    async updateBoardData(context: ActionContext<ProjectState, any>, payload: any) {
      let result = null;
      await Ajax.put("/api/services/app/Project/UpdateBoardData", payload.data)
        .then(response => {
          context.state.currentProject = response.data.result;
          result = response;
        })
        .catch(error => {
          console.log(error);
          return Promise.reject(error);
        });
      return result;
    },
    setLastSelectedProjectId(context: ActionContext<ProjectState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_PROJECT_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedProjectId = newValue;
    },
    setLastSelectedMemberId(context: ActionContext<ProjectState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_PROJECT_MEMBER_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedMemberId = Number(newValue);
    }
  }
};

export default projectModule;
